import { Link } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { MapPin, Phone, CheckCircle2, ArrowRight, Trophy } from 'lucide-react';
import StarRating from './StarRating';

export const CompanyCard = ({ company, isTopRated = false }) => {
  const defaultImage = 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=400&h=300&fit=crop';
  
  return (
    <Card className={`company-card overflow-hidden bg-white border-border/50 group ${isTopRated ? 'ring-2 ring-[#c97f59]' : ''}`} data-testid={`company-card-${company.id}`}>
      <div className="relative h-48 overflow-hidden">
        {isTopRated && (
          <div className="absolute top-3 left-3 z-10">
            <Badge className="bg-[#c97f59] text-white border-0 text-xs font-bold flex items-center gap-1 shadow-md">
              <Trophy className="w-3 h-3" />
              Bedst bedømt
            </Badge>
          </div>
        )}
        <img 
          src={company.photos?.[0] || defaultImage}
          alt={company.company_name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
        {company.logo && (
          <div className="absolute bottom-3 right-3 w-14 h-14 rounded-xl bg-white shadow-lg ring-2 ring-white/60 p-1.5 overflow-hidden">
            <img src={company.logo} alt={`${company.company_name} logo`} className="w-full h-full object-contain" />
          </div>
        )}
        <div className="absolute bottom-3 left-3 right-3 flex items-end justify-between">
          <Badge className="bg-stone-100 text-stone-800 border-0 text-xs font-medium">
            {company.category}
          </Badge>
          {company.verified && (
            <Badge className="bg-green-100 text-green-800 border-0 text-xs font-medium flex items-center gap-1">
              <CheckCircle2 className="w-3 h-3" />
              Verificeret
            </Badge>
          )}
        </div>
      </div>
      
      <CardContent className="p-5">
        <div className="space-y-3">
          <div>
            <h3 className="font-semibold text-lg text-foreground line-clamp-1 group-hover:text-primary transition-colors">
              {company.company_name}
            </h3>
            <div className="flex items-center gap-2 mt-1">
              <StarRating rating={company.trustpilot_rating} size="sm" />
              <span className="text-xs text-muted-foreground">
                ({company.review_count} anmeldelser)
              </span>
            </div>
          </div>

          <p className="text-sm text-muted-foreground line-clamp-2">
            {company.description}
          </p>

          <div className="flex items-center gap-4 text-sm text-muted-foreground">
            <div className="flex items-center gap-1">
              <MapPin className="w-4 h-4" />
              {company.city}
            </div>
            <div className="flex items-center gap-1">
              <Phone className="w-4 h-4" />
              {company.phone}
            </div>
          </div>

          <div className="flex items-center justify-between pt-2 border-t border-border/50">
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <MapPin className="w-4 h-4" />
              {company.city}
            </div>
            <Button asChild size="sm" className="gap-1 bg-primary hover:bg-primary/90" data-testid={`view-company-${company.id}`}>
              <Link to={`/company/${company.id}`}>
                Se profil
                <ArrowRight className="w-4 h-4" />
              </Link>
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default CompanyCard;
